import Vue from 'vue';
import Router from 'vue-router';
import LoginComponent from '@/components/login';
import HomeComponent from '@/components/home';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { container } from '@/app-modules/_ioc';
import { IPersistedStore } from '../store/persisted-store';
import { User } from '@/app-modules/store/modules/user';

Vue.use(Router);

const router: Router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginComponent
    },
    {
      path: '/home',
      name: 'Home',
      component: HomeComponent,
      meta: {
        authenticated: true
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some((route) => route.meta.authenticated)) {
    next();
  }
  else {
    const store: IPersistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore);
    const user: User = store.Get(User);

    if (user.crosscheckId > 0) {
      next();
    }
    else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/router/index.ts